import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { CommonService } from "../../Service/CommonService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import "../Dynamic/UserList.scss";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const ViewContract: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [contract, setContract] = useState<any>();

  useEffect(() => {
    getContractDetails();
  }, []);

  const getContractDetails = async () => {
    try {
      const response = await InventoryApiService.getContractById(id);
      setContract(response.data);
    } catch (error) {
      console.log("error occurred while fetching the contract detail");
    }
  };

  const routeBack = () => {
    history.goBack();
  };

  const handleViewPricing = (id:any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    history.push(`${linkPrefix}/contract-pricing-details/${id}`);
  }

  return (
    <>
      <div className="usersList position-relative">
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center">
          <div className="d-flex flex-wrap justify-content-between gap-4">
            {CommonService.isAdmin() && (
              <div className="d-flex align-items-center gap-1">
                <>
                  <div className="back__button me-1" onClick={routeBack}>
                    <IconButton
                      aria-label="ArrowBackIcon"
                      sx={{ backgroundColor: "#FFF" }}
                    >
                      <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                    </IconButton>
                  </div>
                  <div className="header--title me-3">
                    <h1 className="title mb-0">
                      Contract Details
                      <i className="bi bi-heart-fill"></i>
                    </h1>
                  </div>
                </>
              </div>
            )}
            <div className="person__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Contract ID
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                {contract?.contractId}
              </Typography>
            </div>

            {CommonService.isAdmin() && (
              <div className="person__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Company Name
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                {contract?.companyName}
              </Typography>
            </div>
            )}
          </div>
        </div>
        <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper viewServiceRequest--wrapper viewSupport-req inventory-listing-detail view-contract-detail">
          <div className="no-margin w-100">
            <div className="view-sample-request m-0">
              <div className="row m-0">
                <div className="col-12 px-0">
                  <div
                    className="inventory-file-list-table"
                    style={{ minHeight: "calc(100vh - 175px)" }}
                  >
                    <div className="right-wrapper border-0">
                      <div className="row m-0">
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Contract Type</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.contractType}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Start Date</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {CommonService.formatDateToReadableString(
                                contract?.startDate
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">End Date</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {CommonService.formatDateToReadableString(
                                contract?.endDate
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Term</p>
                            <div className="title-bottom-line"></div>
                            <div className="content-text">
                              {contract?.termMonths}{" "}
                              {`${
                                contract?.termMonths > 1 ? "months" : "month"
                              }`}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Container Type</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.typeOfContainer}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Initial Quantity</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.initialQuantity}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Location Warehouse</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.locationWarehouse}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Contract Pricing</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.contractPricing}
                              <Tooltip
                                title="View Selected Pricing Details"
                                arrow
                              >
                                <IconButton onClick={() => handleViewPricing(contract?.contractPricingId)}>
                                  <ExitToAppIcon />
                                </IconButton>
                              </Tooltip>
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              Early Termination Allowed?
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.isEarlyTermination ? "Yes" : "No"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              Early Termination Penalty
                            </p>
                            <div className="title-bottom-line"></div>
                           <p className="content-text">
                            {(contract?.earlyTerminationPercentage !== null && contract?.earlyTerminationPercentage != undefined)
                              ? `${contract.earlyTerminationPercentage}%`
                              : '-'}
                          </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              Insurance Included with WTDS?
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.insuranceWithWdts ? "Yes" : "No"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Insurance Annual Price
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              ${contract?.insuranceAnnuallyPricePerHundred}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Billing Start Date</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {CommonService.formatDateToReadableString(
                                contract?.billingStartDate
                              )}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Billing Company Name
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingCompanyName}
                            </p>
                          </div>
                        </div>

                         <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Billing Contact Name
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingContactName}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Billing Contact Phone
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingContactPhone}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Billing Contact Email
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingContactEmail}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Billing Address 1</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingAddress1}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Billing Address 2</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingAddress2}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Billing Address 3</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.billingAddress3}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Preferred Payment Method{" "}
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.preferredPaymentMethod || '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Subject to Price Change?
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.isSubjectToPriceChange ? "Yes" : "No"}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Description</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.description || '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Additional Notes</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contract?.additionalNotes || '-'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContract;
